import script from "./ChevronArrowRightIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronArrowRightIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__